import { shipmentAvailabilityRefreshPopulate } from './shipment-populate'

/** Колонки «Наличие» и «Примечание» задания на печать — для опроса без сдвига списка */
export const printJobAvailabilityRefreshPopulate = {
    fields: ['printerComment'],
    populate: {
        shipment: shipmentAvailabilityRefreshPopulate,
    },
}
